<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form :model="detailData" ref="detailData" size="small">
                        <el-form-item prop="row.deliver_type_id">
                            <el-radio-group v-model="detailData.row.deliver_type_id">
                                <el-radio-button
                                    :key="item.key"
                                    :label="item.key"
                                    v-for="item in $store.state.deliverInfo.list"
                                    >{{ item.value }}</el-radio-button
                                >
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            label="发货："
                            prop="row.express_type_id"
                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                        >
                            <el-select v-model="detailData.row.express_type_id" @change="ChangeExpress">
                                <el-option-group
                                    :key="group.label"
                                    :label="group.label"
                                    :value="group.value"
                                    v-for="group in $store.state.expressInfo.list"
                                >
                                    <el-option
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        v-for="item in group.options"
                                        :disabled="
                                            item.key === 23 ||
                                                ((item.key === 11 || item.key === 21 || item.key === 22) &&
                                                    ['西藏自治区', '新疆维吾尔自治区'].indexOf(
                                                        detailParam.row.province
                                                    ) >= 0)
                                        "
                                        :style="item.meta.style"
                                    >
                                        <span style="float: left">{{ item.value }}</span>
                                        <span style="float: right; color: #8492a6">{{ item.label }}</span>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <div
                            :key="index"
                            v-for="(row, index) in detailData.row.details_array"
                            class="el-drawer___group"
                        >
                            <el-form-item
                                :label="
                                    detailData.row.details_array.length === 1 ? '商品：' : '商品：' + (index + 1) + ''
                                "
                                :prop="'row.details_array.' + index + '.product_id'"
                                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                            >
                                <el-select
                                    v-model="row.product_id"
                                    filterable
                                    clearable
                                    @change="
                                        value => {
                                            ChangeProduct(value, index)
                                        }
                                    "
                                >
                                    <el-option
                                        :key="product.id"
                                        :label="product.barcode + ' - ' + product.name"
                                        :value="product.id"
                                        :disabled="disabledData.product.indexOf(product.id) >= 0"
                                        v-for="product in productData.list"
                                    >
                                        <span class="el-select-dropdown__item__l">{{
                                            product.barcode + ' - ' + product.name
                                        }}</span>
                                        <span class="el-select-dropdown__item__r">{{ product.classify.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <template v-if="row.product_id">
                                <el-row :gutter="10">
                                    <el-col :span="8">
                                        <el-form-item
                                            :prop="'row.details_array.' + index + '.unit_id'"
                                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                                        >
                                            <el-select
                                                v-model="row.unit_id"
                                                placeholder="单位"
                                                @change="
                                                    value => {
                                                        ChangeUnit(value, index)
                                                    }
                                                "
                                            >
                                                <el-option
                                                    :key="sku.unit_id"
                                                    :label="sku.unit_label"
                                                    :value="sku.unit_id"
                                                    :disabled="disabledData.unit.indexOf(sku.unit_id) >= 0"
                                                    v-for="sku in row.sku_array"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            :prop="'row.details_array.' + index + '.price'"
                                            :rules="[
                                                { required: true, message: ' ', trigger: 'blur' },
                                                { type: 'number', message: ' ' }
                                            ]"
                                        >
                                            <el-input-number
                                                v-model="row.price"
                                                :precision="2"
                                                controls-position="right"
                                                :disabled="[3, 5].indexOf(row.unit_id) >= 0"
                                                placeholder="单价（元）"
                                                @change="TotalProduct"
                                            ></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            :prop="'row.details_array.' + index + '.num'"
                                            :rules="[
                                                { required: true, message: ' ', trigger: 'blur' },
                                                { type: 'number', message: ' ' }
                                            ]"
                                        >
                                            <el-input-number
                                                v-model="row.num"
                                                :min="1"
                                                :step="1"
                                                controls-position="right"
                                                @change="TotalProduct"
                                            ></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </template>
                        </div>
                        <el-form-item v-if="detailData.row.total">
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <el-button type="primary" plain icon="el-icon-circle-plus" @click="AddProduct"
                                        >商品（合计：{{ detailData.row.total | $separator }} 元）</el-button
                                    >
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item label="优惠：" prop="row.compensate">
                                    <el-input-number
                                        v-model="detailData.row.compensate"
                                        :min="0"
                                        :step="1"
                                        controls-position="right"
                                        @change="TotalProduct"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="运费：" prop="row.freight">
                                    <el-input-number
                                        v-model="detailData.row.freight"
                                        :min="0"
                                        :step="1"
                                        controls-position="right"
                                        @change="TotalProduct"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="应收（销售）：" prop="row.should">
                            <el-input-number
                                v-model="detailData.row.should"
                                :min="0"
                                :precision="2"
                                :step="1"
                                controls-position="right"
                                disabled
                            ></el-input-number>
                        </el-form-item>
                        <template v-if="!detailParam.row.quote">
                            <el-form-item
                                label="付款方式："
                                prop="row.pay_id"
                                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                            >
                                <el-select v-model="detailData.row.pay_id">
                                    <el-option
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        :disabled="
                                            item.key === 11 ||
                                                item.key === 12 ||
                                                item.key === 224 ||
                                                item.key === 225 ||
                                                item.key === 23 ||
                                                item.key === 32 ||
                                                item.key === 33 ||
                                                item.key === 34
                                        "
                                        v-for="item in $store.state.payInfo.list"
                                    >
                                        <span style="float: left">{{ item.value }}</span>
                                        <span style="float: right; color: #8492a6">{{ item.label }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="订单号："
                                prop="row.third_id"
                                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                                v-if="
                                    [21, 211, 212, 213, 214, 22, 221, 222, 223, 224, 225, 23, 24, 25].indexOf(
                                        detailData.row.pay_id
                                    ) >= 0
                                "
                            >
                                <el-input v-model="detailData.row.third_id" placeholder="第三方平台订单号"></el-input>
                            </el-form-item>
                        </template>
                        <el-form-item label="备注：" prop="row.memo">
                            <el-input type="textarea" v-model="detailData.row.memo"></el-input>
                            <el-tag
                                :key="index"
                                v-for="(row, index) in $store.state.orderInfo.memo"
                                size="mini"
                                type="info"
                                @click="detailData.row.memo = row.value"
                                >{{ row.key }}</el-tag
                            >
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :disabled="
                                    (detailData.row.express_type_id === 11 ||
                                        detailData.row.express_type_id === 21 ||
                                        detailData.row.express_type_id === 22 ||
                                        detailData.row.express_type_id === 23) &&
                                        !detailParam.row.address
                                "
                                :loading="detailData.loading.submit"
                                @click="SubmitlDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { CustomerData } from '@/plugin/Customer'
export default {
    inject: ['reload'],
    mixins: [CustomerData],
    props: ['detailParam'],
    watch: {
        ['detailData.row.express_type_id'](n) {
            this.$store.state.expressInfo.list.forEach(item => {
                item.options.forEach(item => {
                    if (item.key === n) {
                        this.disabledData.product = item.meta.exclude.product
                        this.disabledData.unit = item.meta.exclude.unit
                    }
                })
            })
        }
    },
    data() {
        return {
            cooperationData: {
                customer_type_id: null,
                list: []
            },
            productData: {
                used: 0,
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            disabledData: {
                product: [],
                unit: []
            },
            detailData: {
                loading: {
                    form: false,
                    submit: false
                },
                title: this.detailParam.row.quote ? '订单报价' : '订单详情',
                status: null,
                row: {
                    deliver_type_id: 1,
                    express_type_id: null,
                    details_array: [
                        {
                            product_id: null,
                            unit_id: null,
                            price: null,
                            num: null
                        }
                    ],
                    details: null,
                    compensate: null,
                    freight: null,
                    total: null,
                    should: null,
                    pay_id: null,
                    third_id: null,
                    memo: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetCooperation()
            this.GetProduct()
        })
    },
    mounted() {
        this.$nextTick(() => {
            if (this.detailParam.row && this.detailParam.row.id) {
                this.GetOrder()
            }
        })
    },
    methods: {
        // 查看当地是否有经销
        GetCooperation() {
            this.$request({
                url: '/api/v1/agent_area_check',
                params: {
                    province: this.detailParam.row.province,
                    city: this.detailParam.row.city,
                    county: this.detailParam.row.county
                }
            }).then(res => {
                if (!res.status) {
                    this.cooperationData.list = []
                    res.data.forEach(item => {
                        item.productList.forEach(row => {
                            row.forEach(row => {
                                this.cooperationData.list.push({
                                    type_id: item.customer_type_id,
                                    product_id: row.id
                                })
                            })
                        })
                    })
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        // 商品列表
        GetProduct() {
            this.detailData.loading.form = true
            this.$request({
                url: '/api/v1/product',
                params: {
                    order_field: 'sort',
                    order: 'asc',
                    status_id: 1,
                    ...this.productData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.detailData.loading.form = false
                    res.data.list.forEach(product => {
                        this.cooperationData.list.forEach(row => {
                            if (row.product_id === product.id) {
                                product.name =
                                    product.name +
                                    (row.type_id === 1 ? '（经销商）' : row.type_id === 2 ? '（代理商）' : null)
                            }
                        })
                        product.sku_array = JSON.parse(product.sku)
                    })
                    this.productData.list = res.data.list
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        // 修改时获取当前订单信息
        GetOrder() {
            this.detailData.loading.form = true
            this.detailData.row.details_array = []
            this.$request({
                url: '/api/v1/order/' + this.detailParam.row.id
            }).then(res => {
                if (!res.status) {
                    this.detailData.loading.form = false
                    this.detailData.row.deliver_type_id = res.data.deliver_type_id
                    this.detailData.row.express_type_id = res.data.express_type_id
                    res.data.details.forEach(row => {
                        this.detailData.row.details_array.push({
                            product_id: row.product_id,
                            unit_id: row.unit_id,
                            price: row.price,
                            num: row.num,
                            sku_array: JSON.parse(row.product.sku)
                        })
                    })
                    this.detailData.row.total = res.data.total
                    this.detailData.row.compensate = res.data.compensate
                    this.detailData.row.freight = res.data.freight
                    this.detailData.row.should = res.data.should
                    this.detailData.row.pay_id = res.data.pay_id
                    this.detailData.row.third_id = res.data.third_id
                    this.detailData.row.memo = res.data.memo
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        ChangeExpress() {
            this.detailData.row.details_array = this.$options.data.call(this).detailData.row.details_array
        },
        ChangeProduct(value, index) {
            // 移除产品
            if (!this.detailData.row.details_array[index].product_id) {
                if (this.detailData.row.details_array.length > 1) {
                    this.detailData.row.details_array.splice(index, 1)
                }
            } else {
                this.detailData.row.details_array[index].unit_id = null
                this.detailData.row.details_array[index].price = null
                this.detailData.row.details_array[index].num = null
                this.productData.list.forEach(product => {
                    if (product.id === value) {
                        this.detailData.row.details_array[index].sku_array = product.sku_array
                    }
                })
            }
            // this.DisabledProduct()
            this.TotalProduct()
        },
        ChangeUnit(value, index) {
            this.detailData.row.details_array[index].sku_array.forEach(sku => {
                if (sku.unit_id === value) {
                    this.detailData.row.details_array[index].price = sku.price
                }
            })
            this.TotalProduct()
        },
        DisabledProduct() {
            this.productData.used = 0
            this.productData.list.forEach(p => {
                p.disabled = false
                this.detailData.row.details_array.forEach(d => {
                    if (p.id === d.product_id) {
                        if (!d.price) {
                            d.price = p.price
                        }
                        p.disabled = true
                        this.productData.used++
                    }
                })
            })
        },
        AddProduct() {
            this.detailData.row.details_array.push({
                product_id: null,
                unit_id: null,
                price: 0,
                num: 1
            })
        },
        TotalProduct() {
            this.detailData.row.total = this.detailData.row.should = null
            this.detailData.row.details_array.forEach(row => {
                if (row.product_id) {
                    this.detailData.row.total += row.price * row.num
                    this.detailData.row.should =
                        this.detailData.row.total - this.detailData.row.compensate + this.detailData.row.freight
                }
            })
        },
        SubmitlDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.row.details = JSON.stringify(this.detailData.row.details_array)
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/order_add',
                        params: {
                            ...this.detailParam.row,
                            ...this.detailData.row
                        }
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            if (this.$parent.GetOrder === 'function') {
                                this.detailParam.visible = false
                                this.$parent.GetOrder()
                            } else {
                                this.detailParam.visible = false
                                this.$parent.GetOrder()
                            }
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
.el-tag {
    margin-right: 6px;
    cursor: pointer;
}
</style>
